import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { UntypedFormArray } from '@angular/forms';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';
import { AttributionDao } from '@app/dao/attribution/attribution.dao';
import { FormControlOption } from '@app/forms/subscription/definition/interface/formControlOption.interface';
import { PledgeRead } from '../../definition/interface/Pledge';
import { userSocialRegimeOptions } from '../../services/ref';
import { SubscriptionFacadeService } from '../../services/subscription-facade.service';
import { EaSubscriptionBuilder } from './ea-subscription-form.builder';

@Component({
  selector: 'civil-state-form',
  templateUrl: './civil-state-form.component.html',
  styleUrls: ['./civil-state-form.component.scss'],
  standalone: false,
})
export class CivilStateFormComponent
  extends EaSubscriptionBuilder
  implements OnInit
{
  @Input() col: number = 6;

  loanCategories: any[] = [];
  loanTypes: any[] = [];
  productType;
  sessionConsultant: boolean;
  pledge: PledgeRead;

  options: FormControlOption[] = [
    { value: 'M', label: 'Monsieur', suffix: { title: 'A' } },
    { value: 'F', label: 'Madame', suffix: { title: 'B' } },
  ];
  userSocialRegimeOptions = userSocialRegimeOptions;
  cristalisOrganizationId: number = 251251251;
  isCristalisOrganization: boolean;

  constructor(
    protected formConstructor: PrFormConstructor,
    private cd: ChangeDetectorRef,
    private attributionDao: AttributionDao,
    private subscriptionFacade: SubscriptionFacadeService,
  ) {
    super(formConstructor);
  }

  ngOnInit() {
    this.productType = this.subscriptionFacade?.getPledge()?.productType;

    this.pledge = this.subscriptionFacade?.getPledge();
    this.attributionDao.getOrganization().subscribe((data: any) => {
      this.isCristalisOrganization = this.cristalisOrganizationId === data.id;
    });
    this.sessionConsultant =
      !!this.pledge && !!this.subscriptionFacade?.getUser()?.sessionConsultant;
    this.subscriptionFacade.initForm(this, {
      productType: this.productType,
      sessionConsultant: this.sessionConsultant,
      isCristalisOrganization: this.isCristalisOrganization,
      pledgeParameters: this.pledge?.parameters,
      hasSwisslifeProduct: (this.pledge?.products || []).some(
        (product: any) => product?.parameters?.partnerFlux === 'SWISSLIFE',
      ),
    });
  }

  get userOtherFirstNames() {
    return this.form.get('userOtherFirstNames') as UntypedFormArray;
  }
  get owners() {
    return this.form.get('owners') as UntypedFormArray;
  }

  onSubmit() {
    this.subscriptionFacade.submitPledge(this);
  }

  prev() {
    this.subscriptionFacade.previousStep();
  }
}
